import React, { useState, useEffect } from 'react';
import RootModal from '../../../common/RootModal';
import CustomInput from '../../../common/CustomInput';
import Button from '../../../common/Button';
import {
  isHealthCareError,
  isVersionCodeError,
  isValidExpiryDate,
} from "../../../../../src/helpers/input-validations";

const UpdateInsurancePopup = ({ 
  isOpen, 
  onClose, 
  onSaveAndContinue, 
  patientName 
}) => {
  const [healthCardNumber, setHealthCardNumber] = useState('');
  const [healthCardVersionCode, setHealthCardVersionCode] = useState('');
  const [healthCardExpiryDate, setHealthCardExpiryDate] = useState('');
  const [healthCardNumberError, setHealthCardNumberError] = useState(false);
  const [healthCardVersionError, setHealthCardVersionError] = useState(false);
  const [healthCardExpiryError, setHealthCardExpiryError] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setHealthCardNumber('');
      setHealthCardVersionCode('');
      setHealthCardExpiryDate('');
      setHealthCardNumberError(false);
      setHealthCardVersionError(false);
      setHealthCardExpiryError(false);
    }
  }, [isOpen]);

  const isValidDateValue = (dateValue) => {
    if (!dateValue?.trim()) return false;
    const dateObj = new Date(String(dateValue).trim());
    return !isNaN(dateObj.getTime()) && dateObj.getFullYear() > 2000;
  };

  const getCleanDateValue = () => isValidDateValue(healthCardExpiryDate) ? healthCardExpiryDate : '';

  const validateInputs = () => {
    const cardError = isHealthCareError(healthCardNumber);
    const versionError = isVersionCodeError(healthCardVersionCode?.toUpperCase());
    const expiryError = healthCardExpiryDate ? !isValidExpiryDate(healthCardExpiryDate) : false;

    setHealthCardNumberError(cardError);
    setHealthCardVersionError(versionError);
    setHealthCardExpiryError(expiryError);

    return !(cardError || versionError || expiryError);
  };

  const handleSaveAndContinue = () => {
    if (!validateInputs()) return;

    onSaveAndContinue({
      healthCardNumber,
      healthCardVersionCode: healthCardVersionCode.toUpperCase(),
      healthCardExpiryDate: healthCardExpiryDate?.trim() || null
    });
  };

  return (
    <RootModal
      open={isOpen}
      handleClose={onClose}
      title="Update Provincial Insurance"
      titleClassName="text-body-xl font-semibold text-teal-300"
      className="max-w-[600px] overflow-visible"
    >
      <div className="px-6 pb-6">
        <div className="grid grid-cols-12 gap-3">
          <CustomInput
            name="provincialHealthCard"
            className="col-span-12"
            label="Health Card Number"
            mask="9999-999-999"
            placeholder="XXX-XXX-XXX"
            type="text"
            value={healthCardNumber}
            error={healthCardNumberError}
            onChange={(e) => {
              setHealthCardNumber(e.target.value);
              setHealthCardNumberError(isHealthCareError(e.target.value));
            }}
            required
          />
          <CustomInput
            name="provincialVersionCode"
            className="col-span-6"
            label="Version Code"
            placeholder="ER"
            type="versionCode"
            value={healthCardVersionCode}
            error={healthCardVersionError}
            onChange={(e) => {
              const value = e.target.value.toUpperCase();
              setHealthCardVersionCode(value);
              setHealthCardVersionError(isVersionCodeError(value));
            }}
            required
          />
          <CustomInput
            name="provincialExpiryDate"
            className="col-span-6"
            label="Expiry Date"
            type="date"
            value={getCleanDateValue()}
            error={healthCardExpiryError}
            onChange={(value) => {
              const stringValue = value ? String(value).trim() : '';
              const isValid = isValidDateValue(stringValue);
              setHealthCardExpiryDate(isValid ? stringValue : '');
              setHealthCardExpiryError(isValid ? !isValidExpiryDate(stringValue) : false);
            }}
          />
        </div>
        <div className="flex items-center justify-center gap-5 pt-6">
          <Button
            className="min-w-[220px]"
            text="Cancel"
            type="primary-outline"
            onClick={onClose}
          />
          <Button
            className="min-w-[220px]"
            text="Save & Continue"
            type="primary"
            onClick={handleSaveAndContinue}
          />
        </div>
      </div>
    </RootModal>
  );
};

export default UpdateInsurancePopup;